import type { TMessengerErpLayoutMode } from '@xometry/ui';
import { action, observable } from 'mobx';
import type { RootStore } from 'stores/RootStore';
import {
  readErpMessengerLayoutModeFromStorage,
  writeErpMessengerLayoutModeToStorage,
} from 'utils/messenger/erpMessengerLayoutStorage';

export class ErpMessengerLayoutStore {
  @observable userErpMessengerLayoutMode: TMessengerErpLayoutMode = readErpMessengerLayoutModeFromStorage();

  constructor(_rootStore: RootStore) {
    // RootStore reference reserved for future cross-store behaviour
  }

  @action setUserErpMessengerLayoutMode = (mode: TMessengerErpLayoutMode) => {
    if (this.userErpMessengerLayoutMode === mode) return;

    this.userErpMessengerLayoutMode = mode;

    writeErpMessengerLayoutModeToStorage(mode);
  };

  /** MFE "Full messenger" → classic overlay. */
  requestClassicMessengerLayout = () => {
    this.setUserErpMessengerLayoutMode('classic');
  };
}
